import { createContext, useContext, useMemo } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

const ServiceWorkerContext = createContext({
    isUpdateAvailable: false,
    updateAssets: () => {}
});
export const useServiceWorker = () => useContext(ServiceWorkerContext);

// eslint-disable-next-line react/prop-types
export const ServiceWorkerProvider = ({
    children
}: any) => {
    // With autoUpdate, the service worker updates automatically
    // We just register it and let it handle updates in the background
    useRegisterSW({
        onRegistered(r) {
            console.log('SW Registered:', r);
        },
        onRegisterError(error) {
            console.log('SW registration error', error);
        },
    });

    // With autoUpdate mode, we don't show update prompts
    // The service worker will update and activate automatically
    const value = useMemo(() => ({
        isUpdateAvailable: false,
        updateAssets: () => {
            // No-op in autoUpdate mode
        },
    }), []);

    return (
        <ServiceWorkerContext.Provider value={value}>
            {children}
        </ServiceWorkerContext.Provider>
    );
};
